import React, { useEffect } from "react";
import PropTypes from "prop-types";

import FeedsSlider from "./FeedsSlider";

const FACEBOOK_APP_ID = "815910781864360";

const FacebookFeeds = ({ t }) => {
  const feeds = ["ellenwhitewritings"];

  const preloadScript = (id) => {
    if (document.getElementById(id)) {
      return;
    }

    const firstScriptElement = document.getElementsByTagName("script")[0];
    const script = document.createElement("script");
    script.id = id;
    script.src = `https://connect.facebook.net/en_EN/sdk.js#xfbml=1&version=v3.1&appId=${FACEBOOK_APP_ID}&autoLogAppEvents=1`;
    firstScriptElement.parentNode.insertBefore(script, firstScriptElement);
  };

  const renderItem = ({ item }) => {
    return (
      <div
        className="fb-page"
        data-width={9999}
        data-href={`https://www.facebook.com/${item}/`}
        data-tabs="timeline"
        data-small-header="true"
        data-adapt-container-width="true"
        data-hide-cover="false"
        data-show-facepile="false"
      />
    );
  };

  useEffect(() => {
    if (!window.FB) {
      preloadScript("facebook_timeline_widget");
    } else {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <FeedsSlider renderItem={renderItem} records={feeds} containerClassName="facebook-feeds">
      <h3 className="feeds-header">
        {t("follow_us_on")}
        <a
          href="https://www.facebook.com/ellenwhitewritings"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          {t("facebook")}
        </a>
      </h3>
    </FeedsSlider>
  );
};

FacebookFeeds.propTypes = {
  t: PropTypes.func.isRequired
};

export default FacebookFeeds;
